export default "__VITE_ASSET__SRTkvqjW__"